import { createFileRoute } from "@tanstack/react-router"
import { SignupEmailAlreadyExistsPage } from "@/pages/onboarding"

export const Route = createFileRoute("/onboarding/signup-email-already-exists")(
	{
		component: SignupEmailAlreadyExistsPage,
	},
)
